export const TUTORIAL_QUERY_KEY = "tutorial";
export const TUTORIAL_QUERY_VALUE = "1";
export const TUTORIAL_START_EVENT = "coe:tutorial-start";
export const TUTORIAL_FINISH_EVENT = "coe:tutorial-finish";
export const TUTORIAL_HOME_VIEW_EVENT = "coe:tutorial-home-view";
export const TUTORIAL_TARGET_EVENT = "coe:tutorial-target";
/** detail: a news id the play page shows as a read-only bulletin, or null to hide it. */
export const TUTORIAL_NEWS_SAMPLE_EVENT = "coe:tutorial-news-sample";

export type TutorialHomeView = "atlas" | "timeline" | "achievements" | "settings" | "ledger" | "region";

export function isTutorialSearch(search: URLSearchParams, chronicleId?: string): boolean {
  return search.get(TUTORIAL_QUERY_KEY) === TUTORIAL_QUERY_VALUE && (!chronicleId || chronicleId === "carolingian-empire");
}

export function tutorialPath(path: string): string {
  return `${path}${path.includes("?") ? "&" : "?"}${TUTORIAL_QUERY_KEY}=${TUTORIAL_QUERY_VALUE}`;
}

/** Marks the walkthrough's own card. Panels that close on an outside click
 *  ignore presses inside it, so pressing Continue never closes the panel the
 *  tour is explaining (the region list it is about to press, say). */
export const WALKTHROUGH_CARD_ATTR = "data-walkthrough-card";

/** True when a pointer event started on the walkthrough's card. */
export function isWalkthroughEvent(e: Event): boolean {
  const t = e.target as Element | null;
  return !!t && typeof t.closest === "function" && !!t.closest(`[${WALKTHROUGH_CARD_ATTR}]`);
}

let tutorialActive = false;
/** True while the walkthrough is running — pages must not restart it. */
export function isTutorialActive(): boolean { return tutorialActive; }
export function setTutorialActive(value: boolean): void { tutorialActive = value; }
